// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9a26c593","337":"1491df6e","453":"ce10a8ec","667":"6abf2c09"}[chunkId] + ".chunk.js";
};